import { render, staticRenderFns } from "./customerDetails.vue?vue&type=template&id=407fac4e&scoped=true"
import script from "./customerDetails.vue?vue&type=script&lang=js"
export * from "./customerDetails.vue?vue&type=script&lang=js"
import style0 from "./customerDetails.vue?vue&type=style&index=0&id=407fac4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407fac4e",
  null
  
)

export default component.exports